import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reduxForm} from 'redux-form';
import * as commercialActions from 'redux/modules/commercial';

import {
  Row, 
  Col, OverlayTrigger, 
  Tooltip, Alert
} from 'react-bootstrap'; 

var MobileDetect = require('mobile-detect');

import _ from 'underscore';

import moment from 'moment';

import {linuxUserRules, required, maxLength, email, noSpecialChars, minLength} from 'utils/validation';

 
const validate = (values, props) => {
  
  const errors  = {};
  var login     = values.login;
  
  errors['login']     = linuxUserRules(login)||required(login)||noSpecialChars(login)||minLength(3)(login)|| maxLength(8)(login)
  errors['password']  = props.action === 'update' ? undefined : required(values.password)
  errors['email']     = required(values.email) || email(values.email)

      
  return errors
}


import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    createLoading  : state.commercial.createLoading,
    createFail     : state.commercial.createFail,
    createSuccess  : state.commercial.createSuccess,                                    
    updateSuccess  : state.commercial.updateSuccess,
    updateError    : state.commercial.updateError,
  }),
  dispatch => bindActionCreators(commercialActions, dispatch)
)
@reduxForm({
  form: 'commercial',
  fields: [
    'id',
    'login', 
    'email', 
    //'commercial.telephone', 
    //'commercial.nom', 
    //'commercial.prenom', 
    'password',
    //'commercial.societe',         
  ],
  validate: validate,
  //asyncValidating :true
})
export default class CommercialForm extends Component {
  
  
  constructor(props){
    super(props);
   
    this.commercialUpdate = this.commercialUpdate.bind(this);
    
    this.state = {
      showPassword:false,
    }
    
  }
  
   
  commercialUpdate( values ) {

    values = { ...values };
    if (!this.props.fields.password.dirty) delete values.password;
    var sendDiff = false;
    
    
    
    
    //if( dirtyFields.length > 0 ) {                 
      this.props.save(values, this.props.params).then(()=>{this.props.load(this.props.params)});                
    //} else {
      //alert('Aucun changements à enregistrer')      
      
    //}
    

  }

  render() {
    const {
    	editStop,
    	fields, formKey, handleSubmit, invalid,
      pristine, save, submitting,
      //saveError: { [formKey]: saveError },
      values, modules, 
      updateSuccess, 
      updateError, 
      createLoading,
      createFail,
      createSuccess,
      sendingValidationSuccess, 
      sendingValidation, 
      sendingValidationError,
      resetForm,t
    } = this.props;
            
    const styles = require('containers/Client/Clients.scss');
    
    try {
      var md = new MobileDetect(window.navigator.userAgent);
    } catch(e){
      var md = null
    }
        
    if( this.props.action == 'update' ) {
      var btnText = t('main.update_commercial')
    } else {
      var btnText = t('main.create_commercial')
    }
    
    return (
      <div><Row>
        <Col xs={12} md={5}>
          <Row>
            <Col md={9} xs={12}>                            
              <label for="login">
                {t('login.login')}                
              </label>

              <div className={this.props.action == 'update' ? "input-group":""}>
                <input name="login" type="text" className="form-control" {...fields['login']} id="login"/>
                  
                {this.props.action == 'update' &&
                    <span className="input-group-addon">-com</span>
                }
              </div>
              {fields['login'].error && fields['login'].touched && <div className="text-danger">{fields['login'].error}</div>}
            </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="password">{t('login.password')}</label>              
              <div className="input-group">                
                <input name="password" type={this.state.showPassword ? "text":"password"} className="form-control" {...fields['password']} id="password"/>
                {fields['password'].error && fields['password'].touched && <div className="text-danger">{fields['password'].error}</div>}
                <span className="input-group-addon"><i onClick={()=>this.setState({showPassword:!this.state.showPassword})} className={this.state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}/></span>
              </div>
              
              </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="email">{t('main.email')}</label> 
              <input name="email" type="text" className="form-control" {...fields['email']} id="email"/>
              {fields['email'].error && fields['email'].touched && <div className="text-danger">{fields['email'].error}</div>}
            </Col>
          </Row>
          
          
          
          {/*
          <br/>

          <Row>
            <Col md={9} xs={12}>
              <label for="prenom">Prénom</label>
              <input name="prenom" type="text" className="form-control" {...fields['prenom']} id="prenom"/>
              {fields['prenom'].error && fields['prenom'].touched && <div className="text-danger">{fields['prenom'].error}</div>}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md={9} xs={12}>
              <label for="nom">Nom</label>
              <input name="nom" type="text" className="form-control" {...fields['nom']} id="nom"/>
              {fields['nom'].error && fields['nom'].touched && <div className="text-danger">{fields['nom'].error}</div>}
            </Col>
          </Row>
          
          */}
          
          <br/>
          

          {displayFormErrors(fields._meta.errors).length > 0 &&
            <Row>
              <Col md={9} xs={12}>
                <Alert bsStyle='danger'>
                  {t('main.errors_in_form')}              
                  
                </Alert>
              </Col>
            </Row>
            
          }

          
        </Col>


      </Row>
        
        
      
      <Row>
      
      <Col md={5} xs={12}>
        
        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><b>{btnText}</b></Tooltip>}>
          <button className="btn btn-success" disabled={invalid==true}
            onClick={handleSubmit(() =>{
  
             if( this.props.action != 'update' ) {
               this.props.create(values)
               .then(result => {
                 if (result && typeof result.error === 'object') {
                   return Promise.reject(result.error);                   
                 } else {
                   this.props.load(this.props.params)
                 }
               })
             } else {                                                       
               this.commercialUpdate(values)                                    
             }
  
            }
            )}
           >
            <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-floppy-o')}/>
            
          </button>
        
        </OverlayTrigger>
        
        &nbsp;
        
        <OverlayTrigger placement="top" overlay={
          <Tooltip id="tooltip">
            <b>Reset</b>
          </Tooltip>
        }>
        
       
        
        <button className="btn btn-danger"
          onClick={resetForm}>
            <i className="fa fa-ban"/>
        </button>
            
            </OverlayTrigger>
            
        <br/>
       
        
        <Row>
          <Col md={9} xs={12}>
          <p>
          {createSuccess &&
            <div className="alert alert-success" role="alert">                  
              {t('comClientForm.commercial_created')}
            </div>
          }
          
          {createFail &&
            <div className="alert alert-danger" role="alert">                  
              {t('comClientForm.error_commercial_created')}
            </div>
          }
          </p>
          </Col>
        </Row>
        
        
        {updateError||updateSuccess &&
        
          <Row>
            <br/>
            <Col md={9} xs={12}>
            
              {updateError &&
                <div className="alert alert-danger" role="alert">
                  <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                  {t('main.error_update')}
                </div>
              }
                  
              {updateSuccess &&
                <div className="alert alert-success" role="alert">                  
                  {t('main.update_success')}
                </div>
              }

            </Col>
         
        
          </Row>
      
       }
        


        
        
      </Col>
      
      
      {this.props.action == 'update' &&
        <div><br/><br/><br/><br/>
        <button className="btn btn-warning"
          onClick={() => editStop(formKey)}
          disabled={submitting}>
            <i className="fa fa-arrow-left"/> {t('main.back_to_list')}
        </button>&nbsp;</div>
      }
      
      
      {this.props.action == 'create' &&
        <div><br/><br/>
        <button className="btn btn-warning"
          onClick={() => window.history.back()}
          disabled={submitting}>
            <i className="fa fa-arrow-left"/>  {t('main.back_to_list')}
        </button>&nbsp;</div>
      }
      
      
      
      
    </Row>
    
    
    </div>
    
      
      
    );
  }
}


function displayFormErrors(errors){
    
  var content = [];
  
  _.each(errors, (deep)=>{
    
    _.each(deep, (value, key)=>{
      
      content.push(<div>{key} : {value}</div>)

    })
    
  })
  
  
  return content
  
}
